export const OCCUPATIONS = {
  'Agriculture/Forestry/Fishing': [
    {
      label: 'Agriculture Inspector/Grader',
      value: 'Agriculture Inspector/Grader',
    },
    {
      label: 'Arborist',
      value: 'Arborist',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Equipment Operator',
      value: 'Equipment Operator',
    },
    {
      label: 'Farm/Ranch Owner',
      value: 'Farm/Ranch Owner',
    },
    {
      label: 'Farm/Ranch Worker',
      value: 'Farm/Ranch Worker',
    },
    {
      label: 'Fisherman',
      value: 'Fisherman',
    },
    {
      label: 'Florist',
      value: 'Florist',
    },
    {
      label: 'Laborer/Worker',
      value: 'Laborer/Worker',
    },
    {
      label: 'Landscaper',
      value: 'Landscaper',
    },
    {
      label: 'Landscaping/Nursery Worker',
      value: 'Landscaping/Nursery Worker',
    },
    {
      label: 'Logger',
      value: 'Logger',
    },
    {
      label: 'Mill Worker',
      value: 'Mill Worker',
    },
    {
      label: 'Ranger',
      value: 'Ranger',
    },
    {
      label: 'Supervisor',
      value: 'Supervisor',
    },
    {
      label: 'Timber Grader/Scaler',
      value: 'Timber Grader/Scaler',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Art/Design/Media': [
    {
      label: 'Actor',
      value: 'Actor',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Announcer/Broadcaster',
      value: 'Announcer/Broadcaster',
    },
    {
      label: 'Artist/Animator',
      value: 'Artist/Animator',
    },
    {
      label: 'Author/Writer',
      value: 'Author/Writer',
    },
    {
      label: 'Choreography/Dancer',
      value: 'Choreography/Dancer',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Composer/Director',
      value: 'Composer/Director',
    },
    {
      label: 'Curator',
      value: 'Curator',
    },
    {
      label: 'Designer',
      value: 'Designer',
    },
    {
      label: 'Editor',
      value: 'Editor',
    },
    {
      label: 'Journalist/Reporter',
      value: 'Journalist/Reporter',
    },
    {
      label: 'Musician/Singer',
      value: 'Musician/Singer',
    },
    {
      label: 'Photographer',
      value: 'Photographer',
    },
    {
      label: 'Printer',
      value: 'Printer',
    },
    {
      label: 'Producer',
      value: 'Producer',
    },
    {
      label: 'Production Crew',
      value: 'Production Crew',
    },
    {
      label: 'Projectionist',
      value: 'Projectionist',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Ticket Sales/Usher',
      value: 'Ticket Sales/Usher',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Banking/Finance/Real Estate': [
    {
      label: 'Accountant/Auditor',
      value: 'Accountant/Auditor',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Analyst',
      value: 'Analyst',
    },
    {
      label: 'Appraiser-Real Estate',
      value: 'Appraiser-Real Estate',
    },
    {
      label: 'Bookkeeper',
      value: 'Bookkeeper',
    },
    {
      label: 'Broker',
      value: 'Broker',
    },
    {
      label: 'Branch Manager',
      value: 'Branch Manager',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Collections',
      value: 'Collections',
    },
    {
      label: 'Consultant',
      value: 'Consultant',
    },
    {
      label: 'Controller',
      value: 'Controller',
    },
    {
      label: 'CSR/Teller',
      value: 'CSR/Teller',
    },
    {
      label: 'Director/Administrator',
      value: 'Director/Administrator',
    },
    {
      label: 'Executive',
      value: 'Executive',
    },
    {
      label: 'Financial Advisor',
      value: 'Financial Advisor',
    },
    {
      label: 'Investment Banker',
      value: 'Investment Banker',
    },
    {
      label: 'Investor',
      value: 'Investor',
    },
    {
      label: 'Loan/Escrow Processor',
      value: 'Loan/Escrow Processor',
    },
    {
      label: 'Manager-Credit/Loan',
      value: 'Manager-Credit/Loan',
    },
    {
      label: 'Manager-Portfolio/Production',
      value: 'Manager-Portfolio/Production',
    },
    {
      label: 'Manager-Property',
      value: 'Manager-Property',
    },
    {
      label: 'Realtor',
      value: 'Realtor',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Sales Agent/Representative',
      value: 'Sales Agent/Representative',
    },
    {
      label: 'Trader Financial Instruments',
      value: 'Trader Financial Instruments',
    },
    {
      label: 'Underwriter',
      value: 'Underwriter',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Business/Sales/Office': [
    {
      label: 'Account Executive',
      value: 'Account Executive',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Buyer',
      value: 'Buyer',
    },
    {
      label: 'Cashier/Checker',
      value: 'Cashier/Checker',
    },
    {
      label: 'Clerk-Office',
      value: 'Clerk-Office',
    },
    {
      label: 'Consultant',
      value: 'Consultant',
    },
    {
      label: 'Customer Service Representative',
      value: 'Customer Service Representative',
    },
    {
      label: 'Director/Administrator',
      value: 'Director/Administrator',
    },
    {
      label: 'Executive',
      value: 'Executive',
    },
    {
      label: 'H.R. Representative',
      value: 'H.R. Representative',
    },
    {
      label: 'Manager-Department/Store',
      value: 'Manager-Department/Store',
    },
    {
      label: 'Manager-District',
      value: 'Manager-District',
    },
    {
      label: 'Manager-Finance/Insurance',
      value: 'Manager-Finance/Insurance',
    },
    {
      label: 'Manager-Genneral Operations',
      value: 'Manager-Genneral Operations',
    },
    {
      label: 'Manager-H.R./Public Relations',
      value: 'Manager-H.R./Public Relations',
    },
    {
      label: 'Manager-Marketing/Sales',
      value: 'Manager-Marketing/Sales',
    },
    {
      label: 'Manager/Supervisor-Office',
      value: 'Manager/Supervisor-Office',
    },
    {
      label: 'Marketing Researcher',
      value: 'Marketing Researcher',
    },
    {
      label: 'Messenger/Courier',
      value: 'Messenger/Courier',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Sales-Counter/Rental',
      value: 'Sales-Counter/Rental',
    },
    {
      label: 'Sales-Homebased',
      value: 'Sales-Homebased',
    },
    {
      label: 'Sales-Manufacture Rep',
      value: 'Sales-Manufacture Rep',
    },
    {
      label: 'Sales-Retail/Wholesale',
      value: 'Sales-Retail/Wholesale',
    },
    {
      label: 'Sales-Route/Vendor',
      value: 'Sales-Route/Vendor',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Construction/Energy/Mining': [
    {
      label: 'Appraiser-Real Estate',
      value: 'Appraiser-Real Estate',
    },
    {
      label: 'Boiler Operator/Maker',
      value: 'Boiler Operator/Maker',
    },
    {
      label: 'Bricklayer/Mason',
      value: 'Bricklayer/Mason',
    },
    {
      label: 'Carpenter',
      value: 'Carpenter',
    },
    {
      label: 'Carpet Installer',
      value: 'Carpet Installer',
    },
    {
      label: 'Concrete Worker',
      value: 'Concrete Worker',
    },
    {
      label: 'Construction-Project Manager',
      value: 'Construction-Project Manager',
    },
    {
      label: 'Construction Worker',
      value: 'Construction Worker',
    },
    {
      label: 'Contractor',
      value: 'Contractor',
    },
    {
      label: 'Crane Operator',
      value: 'Crane Operator',
    },
    {
      label: 'Floor Layer/Finisher',
      value: 'Floor Layer/Finisher',
    },
    {
      label: 'Foreman/Supervisor',
      value: 'Foreman/Supervisor',
    },
    {
      label: 'Handyman',
      value: 'Handyman',
    },
    {
      label: 'Heat/Air Technician',
      value: 'Heat/Air Technician',
    },
    {
      label: 'Inspector',
      value: 'Inspector',
    },
    {
      label: 'Laborer/Worker',
      value: 'Laborer/Worker',
    },
    {
      label: 'Metalworker',
      value: 'Metalworker',
    },
    {
      label: 'Miner',
      value: 'Miner',
    },
    {
      label: 'Oil/Gas Driller/Rig Operator',
      value: 'Oil/Gas Driller/Rig Operator',
    },
    {
      label: 'Painter',
      value: 'Painter',
    },
    {
      label: 'Plaster/Drywall/Stucco',
      value: 'Plaster/Drywall/Stucco',
    },
    {
      label: 'Plumber',
      value: 'Plumber',
    },
    {
      label: 'Utility Worker',
      value: 'Utility Worker',
    },
    {
      label: 'Welder',
      value: 'Welder',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Education/Library': [
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Audio-Visual Tech',
      value: 'Audio-Visual Tech',
    },
    {
      label: 'Child/Daycare Worker',
      value: 'Child/Daycare Worker',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Counselor',
      value: 'Counselor',
    },
    {
      label: 'Graduate Teaching Assistant',
      value: 'Graduate Teaching Assistant',
    },
    {
      label: 'Instructor-Vocation',
      value: 'Instructor-Vocation',
    },
    {
      label: 'Librarian/Curator',
      value: 'Librarian/Curator',
    },
    {
      label: 'Principal',
      value: 'Principal',
    },
    {
      label: 'Professor College',
      value: 'Professor College',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Superintendent',
      value: 'Superintendent',
    },
    {
      label: 'Teacher College',
      value: 'Teacher College',
    },
    {
      label: 'Teacher K-12',
      value: 'Teacher K-12',
    },
    {
      label: 'Teaching Assistant/Aide',
      value: 'Teaching Assistant/Aide',
    },
    {
      label: 'Tutor',
      value: 'Tutor',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Engineer/Architect/Science/Math': [
    {
      label: 'Actuary',
      value: 'Actuary',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Analyst',
      value: 'Analyst',
    },
    {
      label: 'Architec',
      value: 'Architec',
    },
    {
      label: 'Chemist',
      value: 'Chemist',
    },
    {
      label: 'Clerck',
      value: 'Clerck',
    },
    {
      label: 'Clinical Data Coordinator',
      value: 'Clinical Data Coordinator',
    },
    {
      label: 'Drafter',
      value: 'Drafter',
    },
    {
      label: 'Engineer',
      value: 'Engineer',
    },
    {
      label: 'Lab Assistant',
      value: 'Lab Assistant',
    },
    {
      label: 'Manager-Project',
      value: 'Manager-Project',
    },
    {
      label: 'Manager-R&D',
      value: 'Manager-R&D',
    },
    {
      label: 'Mathematician',
      value: 'Mathematician',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Reserch Program Director',
      value: 'Reserch Program Director',
    },
    {
      label: 'Researcher',
      value: 'Researcher',
    },
    {
      label: 'Scientist',
      value: 'Scientist',
    },
    {
      label: 'Sociologist',
      value: 'Sociologist',
    },
    {
      label: 'Surveyor/Mapmaker',
      value: 'Surveyor/Mapmaker',
    },
    {
      label: 'Technician',
      value: 'Technician',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Food Service/Hotel Services': [
    {
      label: 'Baker',
      value: 'Baker',
    },
    {
      label: 'Bartender',
      value: 'Bartender',
    },
    {
      label: 'Bellhop',
      value: 'Bellhop',
    },
    {
      label: 'Bus Person',
      value: 'Bus Person',
    },
    {
      label: 'Caterer',
      value: 'Caterer',
    },
    {
      label: 'Chef',
      value: 'Chef',
    },
    {
      label: 'Concessionaire',
      value: 'Concessionaire',
    },
    {
      label: 'Concierge',
      value: 'Concierge',
    },
    {
      label: 'Cook-Restaurant/Cafeteria',
      value: 'Cook-Restaurant/Cafeteria',
    },
    {
      label: 'Cook/Worker-Fast Food',
      value: 'Cook/Worker-Fast Food',
    },
    {
      label: 'Delivery Person',
      value: 'Delivery Person',
    },
    {
      label: 'Desk Clerk',
      value: 'Desk Clerk',
    },
    {
      label: 'Dishwasher',
      value: 'Dishwasher',
    },
    {
      label: 'Food Production/Packing',
      value: 'Food Production/Packing',
    },
    {
      label: "Host/Maitre d'",
      value: "Host/Maitre d'",
    },
    {
      label: 'Housekeeper/Maid',
      value: 'Housekeeper/Maid',
    },
    {
      label: 'Manager',
      value: 'Manager',
    },
    {
      label: 'Valet',
      value: 'Valet',
    },
    {
      label: 'Waiter/Waitress',
      value: 'Waiter/Waitress',
    },
    {
      label: 'Wine Steward',
      value: 'Wine Steward',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Government/Military': [
    {
      label: 'Accountant/Auditor',
      value: 'Accountant/Auditor',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Analyst',
      value: 'Analyst',
    },
    {
      label: 'Attorney',
      value: 'Attorney',
    },
    {
      label: 'Chief Executive',
      value: 'Chief Executive',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Commissioner',
      value: 'Commissioner',
    },
    {
      label: 'Council Member',
      value: 'Council Member',
    },
    {
      label: 'Director/Administrator',
      value: 'Director/Administrator',
    },
    {
      label: 'Enlisted Military Personnel(E1-E4)',
      value: 'Enlisted Military Personnel(E1-E4)',
    },
    {
      label: 'Legislator',
      value: 'Legislator',
    },
    {
      label: 'Mayor/City Manager',
      value: 'Mayor/City Manager',
    },
    {
      label: 'Meter Reader',
      value: 'Meter Reader',
    },
    {
      label: 'NCO (E5-9)',
      value: 'NCO (E5-9)',
    },
    {
      label: 'Officer-Commissioned',
      value: 'Officer-Commissioned',
    },
    {
      label: 'Officer-Warrant',
      value: 'Officer-Warrant',
    },
    {
      label: 'Park Ranger',
      value: 'Park Ranger',
    },
    {
      label: 'Planner',
      value: 'Planner',
    },
    {
      label: 'Postmaster',
      value: 'Postmaster',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Regulator',
      value: 'Regulator',
    },
    {
      label: 'US Postal Worker',
      value: 'US Postal Worker',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Homemaker(full-time)': [
    {
      label: 'Homemaker(full-time)',
      value: 'Homemaker(full-time)',
    },
  ],
  'Information Technology': [
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Analyst',
      value: 'Analyst',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Director/Administrator',
      value: 'Director/Administrator',
    },
    {
      label: 'Engineer-Hardware',
      value: 'Engineer-Hardware',
    },
    {
      label: 'Engineer-Software',
      value: 'Engineer-Software',
    },
    {
      label: 'Engineer-Systems',
      value: 'Engineer-Systems',
    },
    {
      label: 'Executive',
      value: 'Executive',
    },
    {
      label: 'Manager-Systems',
      value: 'Manager-Systems',
    },
    {
      label: 'Network Administrator',
      value: 'Network Administrator',
    },
    {
      label: 'Programmer',
      value: 'Programmer',
    },
    {
      label: 'Project Coordinator',
      value: 'Project Coordinator',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Support Technician',
      value: 'Support Technician',
    },
    {
      label: 'Systems Security',
      value: 'Systems Security',
    },
    {
      label: 'Technical Writer',
      value: 'Technical Writer',
    },
    {
      label: 'Web Developer',
      value: 'Web Developer',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  Insurance: [
    {
      label: 'Accountant/Auditor',
      value: 'Accountant/Auditor',
    },
    {
      label: 'Actuary',
      value: 'Actuary',
    },
    {
      label: 'Actuarial Clerk',
      value: 'Actuarial Clerk',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Agent/Broker',
      value: 'Agent/Broker',
    },
    {
      label: 'Analyst',
      value: 'Analyst',
    },
    {
      label: 'Attorney',
      value: 'Attorney',
    },
    {
      label: 'Claims Adjuster',
      value: 'Claims Adjuster',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Commissioner',
      value: 'Commissioner',
    },
    {
      label: 'Customer Service Representative',
      value: 'Customer Service Representative',
    },
    {
      label: 'Director/Administrator',
      value: 'Director/Administrator',
    },
    {
      label: 'Executive',
      value: 'Executive',
    },
    {
      label: 'Insurance CSR',
      value: 'Insurance CSR',
    },
    {
      label: 'Product Manager',
      value: 'Product Manager',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Sales Representative',
      value: 'Sales Representative',
    },
    {
      label: 'Underwriter',
      value: 'Underwriter',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Legal/Law Enforcement/Security': [
    {
      label: 'Airport Security Officer',
      value: 'Airport Security Officer',
    },
    {
      label: 'Animal Control Officer',
      value: 'Animal Control Officer',
    },
    {
      label: 'Attorney',
      value: 'Attorney',
    },
    {
      label: 'Bailiff',
      value: 'Bailiff',
    },
    {
      label: 'Corrections Officer',
      value: 'Corrections Officer',
    },
    {
      label: 'Court Clerck/Reporter',
      value: 'Court Clerck/Reporter',
    },
    {
      label: 'Deputy Sheriff',
      value: 'Deputy Sheriff',
    },
    {
      label: 'Dispatcher',
      value: 'Dispatcher',
    },
    {
      label: 'Examiner',
      value: 'Examiner',
    },
    {
      label: 'Federal Agent/Marshall',
      value: 'Federal Agent/Marshall',
    },
    {
      label: 'Fire Chief',
      value: 'Fire Chief',
    },
    {
      label: 'Fire Fighter/Supervisor',
      value: 'Fire Fighter/Supervisor',
    },
    {
      label: 'Gaming Officer/Investigator',
      value: 'Gaming Officer/Investigator',
    },
    {
      label: 'Highway Patrol Officer',
      value: 'Highway Patrol Officer',
    },
    {
      label: 'Judge/Hearing Officer',
      value: 'Judge/Hearing Officer',
    },
    {
      label: 'Legal Assistant/Secretary',
      value: 'Legal Assistant/Secretary',
    },
    {
      label: 'Paralegal/Law Clerk',
      value: 'Paralegal/Law Clerk',
    },
    {
      label: 'Police Chief',
      value: 'Police Chief',
    },
    {
      label: 'Police Detective/Investigator',
      value: 'Police Detective/Investigator',
    },
    {
      label: 'Police Officer/Supervisor',
      value: 'Police Officer/Supervisor',
    },
    {
      label: 'Private Investigator/Detective',
      value: 'Private Investigator/Detective',
    },
    {
      label: 'Process Server',
      value: 'Process Server',
    },
    {
      label: 'Security Guard',
      value: 'Security Guard',
    },
    {
      label: 'Sheriff',
      value: 'Sheriff',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Medical/Social Services/Religion': [
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Assistant-Medic/Dent/Vet',
      value: 'Assistant-Medic/Dent/Vet',
    },
    {
      label: 'Chiropractor',
      value: 'Chiropractor',
    },
    {
      label: 'Clergy',
      value: 'Clergy',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Client Care Worker',
      value: 'Client Care Worker',
    },
    {
      label: 'Dental Hygienist',
      value: 'Dental Hygienist',
    },
    {
      label: 'Dentist',
      value: 'Dentist',
    },
    {
      label: 'Dietician',
      value: 'Dietician',
    },
    {
      label: 'Doctor',
      value: 'Doctor',
    },
    {
      label: 'Hospice Volunteer',
      value: 'Hospice Volunteer',
    },
    {
      label: 'Lab Assistant',
      value: 'Lab Assistant',
    },
    {
      label: 'Mortician',
      value: 'Mortician',
    },
    {
      label: 'Nurse-C.N.A.',
      value: 'Nurse-C.N.A.',
    },
    {
      label: 'Nurse-LPN',
      value: 'Nurse-LPN',
    },
    {
      label: 'Nurse-RN',
      value: 'Nurse-RN',
    },
    {
      label: 'Nurse Practioner',
      value: 'Nurse Practioner',
    },
    {
      label: 'Optometrist',
      value: 'Optometrist',
    },
    {
      label: 'Orthodontist',
      value: 'Orthodontist',
    },
    {
      label: 'Paramedic/E.M. Technician',
      value: 'Paramedic/E.M. Technician',
    },
    {
      label: 'Pharmacist',
      value: 'Pharmacist',
    },
    {
      label: 'Physical Therapist',
      value: 'Physical Therapist',
    },
    {
      label: 'Psychologist',
      value: 'Psychologist',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Social Worker',
      value: 'Social Worker',
    },
    {
      label: 'Support Services',
      value: 'Support Services',
    },
    {
      label: 'Technician',
      value: 'Technician',
    },
    {
      label: 'Therapist',
      value: 'Therapist',
    },
    {
      label: 'Veterinarian',
      value: 'Veterinarian',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Personal Care/Service': [
    {
      label: 'Caregiver',
      value: 'Caregiver',
    },
    {
      label: 'Dry Cleaner/Laundry',
      value: 'Dry Cleaner/Laundry',
    },
    {
      label: 'Hair Stylist/Barber',
      value: 'Hair Stylist/Barber',
    },
    {
      label: 'Housekeeper',
      value: 'Housekeeper',
    },
    {
      label: 'Manicurist',
      value: 'Manicurist',
    },
    {
      label: 'Masseuse',
      value: 'Masseuse',
    },
    {
      label: 'Nanny',
      value: 'Nanny',
    },
    {
      label: 'Pet Services',
      value: 'Pet Services',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Production/Manufacturing': [
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Factory Worker',
      value: 'Factory Worker',
    },
    {
      label: 'Foreman/Supervisor',
      value: 'Foreman/Supervisor',
    },
    {
      label: 'Furniture Finisher',
      value: 'Furniture Finisher',
    },
    {
      label: 'Inspector',
      value: 'Inspector',
    },
    {
      label: 'Jeweler',
      value: 'Jeweler',
    },
    {
      label: 'Machine Operator',
      value: 'Machine Operator',
    },
    {
      label: 'Packer',
      value: 'Packer',
    },
    {
      label: 'Plant Manager',
      value: 'Plant Manager',
    },
    {
      label: 'Printer/Bookbinder',
      value: 'Printer/Bookbinder',
    },
    {
      label: 'Quality Control',
      value: 'Quality Control',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Refining Operator',
      value: 'Refining Operator',
    },
    {
      label: 'Shoemaker',
      value: 'Shoemaker',
    },
    {
      label: 'Tailor/Custom Sewer',
      value: 'Tailor/Custom Sewer',
    },
    {
      label: 'Textile Worker',
      value: 'Textile Worker',
    },
    {
      label: 'Upholsterer',
      value: 'Upholsterer',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Repair/Maintenance/Grounds': [
    {
      label: 'Building Maintenance Engineer',
      value: 'Building Maintenance Engineer',
    },
    {
      label: 'Custodian/Janitor',
      value: 'Custodian/Janitor',
    },
    {
      label: 'Electrician',
      value: 'Electrician',
    },
    {
      label: 'Field Service Technician',
      value: 'Field Service Technician',
    },
    {
      label: 'Handyman',
      value: 'Handyman',
    },
    {
      label: 'Heat/Air Conditioner Repairman',
      value: 'Heat/Air Conditioner Repairman',
    },
    {
      label: 'Housekeeper/Maid',
      value: 'Housekeeper/Maid',
    },
    {
      label: 'Landscape/Grounds Maintenance',
      value: 'Landscape/Grounds Maintenance',
    },
    {
      label: 'Maintenance Mechanic',
      value: 'Maintenance Mechanic',
    },
    {
      label: 'Mechanic',
      value: 'Mechanic',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Retired(full-time)': [
    {
      label: 'Retired(full-time)',
      value: 'Retired(full-time)',
    },
  ],
  'Sports/Recreation': [
    {
      label: 'Activity/Recreational Assistant',
      value: 'Activity/Recreational Assistant',
    },
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Agent',
      value: 'Agent',
    },
    {
      label: 'Athlete',
      value: 'Athlete',
    },
    {
      label: 'Camp Counselor/Lead',
      value: 'Camp Counselor/Lead',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Coach',
      value: 'Coach',
    },
    {
      label: 'Concessionaire',
      value: 'Concessionaire',
    },
    {
      label: 'Director Program',
      value: 'Director Program',
    },
    {
      label: 'Event Manager/Promoter',
      value: 'Event Manager/Promoter',
    },
    {
      label: 'Life Guard',
      value: 'Life Guard',
    },
    {
      label: 'Manager-Fitness Club',
      value: 'Manager-Fitness Club',
    },
    {
      label: 'Park Ranger',
      value: 'Park Ranger',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Sales-Ticket/Membership',
      value: 'Sales-Ticket/Membership',
    },
    {
      label: 'Sports Broadcast/Journalist',
      value: 'Sports Broadcast/Journalist',
    },
    {
      label: 'Trainer/Instructor',
      value: 'Trainer/Instructor',
    },
    {
      label: 'Umpire/Referee',
      value: 'Umpire/Referee',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  'Student(full-time)': [
    {
      label: 'Student(full-time)',
      value: 'Student(full-time)',
    },
  ],
  'Travel/Transportation/Storage': [
    {
      label: 'Administrative Assistant',
      value: 'Administrative Assistant',
    },
    {
      label: 'Airport Operations Crew',
      value: 'Airport Operations Crew',
    },
    {
      label: 'Bellhop/Porter',
      value: 'Bellhop/Porter',
    },
    {
      label: 'Clerk',
      value: 'Clerk',
    },
    {
      label: 'Crane Loader/Operator',
      value: 'Crane Loader/Operator',
    },
    {
      label: 'Dispatcher',
      value: 'Dispatcher',
    },
    {
      label: 'Driver-Bus/Streetcar',
      value: 'Driver-Bus/Streetcar',
    },
    {
      label: 'Driver-Taxi/Limo',
      value: 'Driver-Taxi/Limo',
    },
    {
      label: 'Driver-Truck/Delivery',
      value: 'Driver-Truck/Delivery',
    },
    {
      label: 'Flight Attendant',
      value: 'Flight Attendant',
    },
    {
      label: 'Laborer',
      value: 'Laborer',
    },
    {
      label: 'Longshoreman',
      value: 'Longshoreman',
    },
    {
      label: 'Manager-Warehouse/District',
      value: 'Manager-Warehouse/District',
    },
    {
      label: 'Mate/Sailor',
      value: 'Mate/Sailor',
    },
    {
      label: 'Parking Lot Attendant',
      value: 'Parking Lot Attendant',
    },
    {
      label: 'Pilot/Captain/Engineer',
      value: 'Pilot/Captain/Engineer',
    },
    {
      label: 'Railroad Worker',
      value: 'Railroad Worker',
    },
    {
      label: 'Receptionist/Secretary',
      value: 'Receptionist/Secretary',
    },
    {
      label: 'Subway/Light Rail Operator',
      value: 'Subway/Light Rail Operator',
    },
    {
      label: 'Ticket Agent',
      value: 'Ticket Agent',
    },
    {
      label: 'Transportation Specialist',
      value: 'Transportation Specialist',
    },
    {
      label: 'Travel Agent',
      value: 'Travel Agent',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
  Unemployed: [
    {
      label: 'Unemployed',
      value: 'Unemployed',
    },
  ],
};
